/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}


function initBlickStepDownloadLinks() {
  const stepFiles = {
    '/products/side-entry-up-down-d-sub-backshell': 'https://cdn.shopify.com/s/files/1/0752/1789/5607/files/DE-DRAFT20260620.step',
    '/products/low-profile-90-d-sub-backshell-side-entry-copy': 'https://cdn.shopify.com/s/files/1/0752/1789/5607/files/DE-DRAFT20260620_nylon.step',
  };

  const stepUrl = stepFiles[window.location.pathname];
  if (!stepUrl) return;

  document
    .querySelectorAll('a[href="#3d-model-download"], a[href*="admin.shopify.com/store/blick-connections/content/files"]')
    .forEach((link) => {
      link.setAttribute('href', stepUrl);
      link.setAttribute('download', '');
      if (link.textContent.trim() === 'Download') {
        link.textContent = 'Download STEP file';
      }
    });
}

if (document.readyState === 'loading') {
  d
function initBlickExactStepDownloadLinks() {
  const stepFiles = {
    '/products/side-entry-up-down-d-sub-backshell': 'https://cdn.shopify.com/s/files/1/0752/1789/5607/files/DE-DRAFT20260620.step?v=1781983089',
    '/products/low-profile-90-d-sub-backshell-side-entry-copy': 'https://cdn.shopify.com/s/files/1/0752/1789/5607/files/DE-DRAFT20260620_nylon.step?v=1783788795',
  };

  const stepUrl = stepFiles[window.location.pathname];
  if (!stepUrl) return;

  document
    .querySelectorAll('a[href="#3d-model-download"], a[href*="admin.shopify.com/store/blick-connections/content/files"], a[href*="DE-DRAFT20260620.step"], a[href*="DE-DRAFT20260620_nylon.step"]')
    .forEach((link) => {
      link.setAttribute('href', stepUrl);
      link.setAttribute('download', '');
      if (link.textContent.trim() === 'Download') {
        link.textContent = 'Download STEP file';
      }
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlickExactStepDownloadLinks, { once: true });
} else {
  initBlickExactStepDownloadLinks();
}
ocument.addEventListener('DOMContentLoaded', initBlickStepDownloadLinks, { once: true });
} else {
  initBlickStepDownloadLinks();
}


// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
